App = App || {};

App.TransactionLog = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("transaction-log");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = true;

		new Vue({
			el: rootElement,
			data: {
				fieldDefs: [
					{ key: "id", label: "Id", sortable: true },
					{ key: "initiatedOn", label: "Date", sortable: true },
					{ key: "type", label: "Type", sortable: true },
					{ key: "status", label: "Status", sortable: true },
					{ key: "userName", label: "User", sortable: false },
					{ key: "amount", label: "Amount", sortable: false },
					{ key: "balance", label: "Balance", sortable: false },
					{ key: "comment", label: "Comment", sortable: false }
				],
				isLoading: false,
				page: 1,
				pageSize: 10,
				sortBy: "initiatedOn",
				sortDesc: true,
				searchTerm: "",
				totalItems: 0,
				firstItem: 0,
				lastItem: 0,

				memberSuggestions: [],
				memberLoading: false,
				memberLookupTimer: null,
				activeMemberRequest: null,
				suggestionsOpen: false,
				highlightedIndex: 0,
				filters: {
					transactionId: null,
					memberId: String(rootElement.getAttribute("data-id")) || "",
					name: String(rootElement.getAttribute("data-name")) || "",
					dateFrom: "",
					dateTo: "",
					status: ""
				}
			},

			computed: {
				fieldsWithColumnSelect: function () {
					var viewModel = this;
					return viewModel.fieldDefs.map((field) => {
						var sortedClass = viewModel.sortBy === field.key ? "is-sorted" : "";
						return Object.assign({}, field, { thClass: sortedClass, tdClass: sortedClass });
					});
				},

				totalPages: function () {
					return Math.max(1, Math.ceil((this.totalItems || 0) / (this.pageSize || 1)));
				},
			},

			methods: {
				provider: function (context) {
					var requestParameters = {
						transactionId: this.filters?.transactionId,
						memberId: this.filters?.memberId,
						fromUtc: this.localDateToUtcIso(this.filters?.dateFrom),
						toUtc: this.localDateToUtcIso(this.filters?.dateTo),
						status: this.filters?.status,
						page: context.currentPage,
						pageSize: context.perPage,
						sortBy: context.sortBy || this.sortBy || "",
						sortDir: (context.sortDesc === true) ? "desc" : "asc"
					};

					return $.ajax({
						url: "/api/members/transactions",
						method: "GET",
						dataType: "json",
						data: requestParameters,
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							context.currentPage = response.data.page;
							context.perPage = response.data.pageSize;
							this.totalItems = response.data.total;
							this.firstItem = response.data.firstItem;
							this.lastItem = response.data.lastItem;
							return response.data.items;
						}

						context.totalItems = 0;
						return [];

					}).catch((error) => {
						console.error("BalanceHistory provider error:", error);
						context.totalItems = 0;
						return [];
					});
				},

				reset: function () {
					this.page = 1;
					this.$refs.table.refresh();
				},

				redraw: function () {
					this.$refs.table.refresh();
				},

				localDateToUtcIso(dateString) {
					if (!dateString)
						return null;
					return new Date(`${dateString}T00:00:00`).toISOString();
				},

				formatDate(value) {
					if (!value) return "";

					const date = new Date(value);
					if (isNaN(date)) return String(value);

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				formatPoints: function (value) {
					var amount = Number(value);
					return (amount < 0) ? "(" + Math.abs(amount) + ")" : Math.abs(amount);
				},

				pointsClass: function (value) {
					return (Number(value) < 0) ? "text-danger" : "";
				},

				onRowClicked: function (item, index, evt) {
					if (!item || !item.id)
						return;

					if (window.App && App.TransactionDetail && App.TransactionDetail.open) {
						App.TransactionDetail.open(item.id, () => this.redraw());
					}
				},

				openSuggestions: function () {
					this.suggestionsOpen = true;
				},

				closeSuggestions: function () {
					this.suggestionsOpen = false;
					this.highlightedIndex = 0;
				},

				deferClose: function () {
					setTimeout(() => this.closeSuggestions(), 120);
				},

				scrollHighlightedIntoView: function () {
					this.$nextTick(() => {
						var dropdown = this.$el.querySelector("#member-suggestions");
						if (!dropdown) return;

						var active = dropdown.querySelector('[role="option"][aria-selected="true"]');
						if (active && typeof active.scrollIntoView === "function") {
							active.scrollIntoView({ block: "nearest" });
						}
					});
				},

				move: function (dir) {
					if (!this.memberSuggestions.length)
						return;

					var max = this.memberSuggestions.length - 1;
					var next = this.highlightedIndex + dir;
					if (next < 0)
						next = max;

					if (next > max)
						next = 0;

					this.highlightedIndex = next;
					this.scrollHighlightedIntoView();
				},

				commitSelection: function (evt) {
					if (this.memberSuggestions && this.memberSuggestions.length) {
						this.selectMember(this.memberSuggestions[this.highlightedIndex]);
						return;
					}

					this.clearMemberFilter();
				},

				selectMember: function (member) {
					this.filters.memberId = member.id;
					this.filters.name = member.nodeName;
					this.closeSuggestions();
					this.reset();
				},

				clearMemberFilter: function () {
					this.filters.memberId = null;
					this.filters.name = "";
					this.memberSuggestions = [];
					this.closeSuggestions();
					this.reset();
				},

				findMembers: function () {
					this.memberLookupTimer = null;
					this.activeMemberRequest = $.ajax({
						url: "/api/members/autocomplete?term=" + this.filters.name,
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000,
						cache: true
					}).done((response) => {
						if (response && response.success === true) {
							this.memberSuggestions = response.data || [];
						} else {
							this.memberSuggestions = [];
						}

						if (this.suggestionsOpen && this.memberSuggestions.length > 0) {
							this.highlightedIndex = 0;
							this.scrollHighlightedIntoView();
						}
					}).fail((jqXHR, status) => {
						if (status === "abort")
							return;
						this.memberSuggestions = [];
					}).always(() => {
						this.activeMemberRequest = null;
						this.memberLoading = false;
					});
				}
			},

			mounted: function () {
				var vm = this;

				vm._watchfilters = vm.$watch("filters.name", function () {
					if (vm.memberLookupTimer) {
						clearTimeout(vm.memberLookupTimer);
						vm.memberLookupTimer = null;
					}

					if (vm.activeMemberRequest && vm.activeMemberRequest.abort) {
						try { vm.activeMemberRequest.abort(); } catch (_) { }
						vm.activeMemberRequest = null;
					}

					if (vm.filters.name.length < 4) {
						vm.memberLoading = false;
						vm.memberSuggestions = [];
						return;
					}

					vm.memberLoading = true;
					vm.memberLookupTimer = setTimeout(vm.findMembers, 250);
				}, { immediate: true });

				vm.$nextTick(function () {
					if (vm.$refs.table && vm.$refs.table.refresh)
						vm.$refs.table.refresh();
				});
			},

			beforeDestroy: function () {
				if (this._watchfilters) {
					this._watchfilters = null;
				}
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.TransactionLog.init();
